import SupportContacts from './SupportContacts';

export default SupportContacts;
